import { useMemo } from "react";

import { useTranslation } from "react-i18next";

import useToast from "./useToast";

const useClipboard = () => {
	const { showToast } = useToast();

	const { t } = useTranslation();

	const methods = useMemo(
		() => ({
			writeToClipboard: async (text: string, showDefaultMessage = true): Promise<boolean> => {
				try {
					await navigator.clipboard.writeText(text);

					if (showDefaultMessage) {
						showToast({ text: t("copied_to_clipboard"), noIcon: true });
					}

					return true;
				} catch (error) {
					console.error("Failed to copy: ", error);
					showToast({ text: "Can't copy to clipboard as user denied permission" });
					return false;
				}
			}
		}),
		[showToast, t]
	);

	return { ...methods };
};

export default useClipboard;
